/**
 * Values slider — COREEX
 * - Initializes a draggable/scrollable Swiper for the value cards.
 * - Intercepts native <details>/<summary> toggling on each card panel and
 *   animates the height with WAAPI, using one shared duration for both
 *   opening and closing (same approach as the benefits-accordion panel).
 * - Optional "single open" mode closes any other open panel first.
 */
(function () {
  var ROOT_SELECTOR = '[data-coreex-values]';

  document.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
    initSlider(root);
    initPanels(root);
  });

  function initSlider(root) {
    var container = root.querySelector('.values-swiper');
    if (!container || typeof Swiper === 'undefined') return;

    var slidesDesktop = parseFloat(container.dataset.slidesDesktop) || 3;
    var slidesTablet = Math.max(2, slidesDesktop - 1);
    var gapDesktop = parseFloat(container.dataset.gapDesktop) || 24;
    var gapMobile = parseFloat(container.dataset.gapMobile) || 16;

    // eslint-disable-next-line no-new
    new Swiper(container, {
      slidesPerView: 1.15,
      spaceBetween: gapMobile,
      grabCursor: true,
      watchOverflow: true,
      breakpoints: {
        741: { slidesPerView: slidesTablet, spaceBetween: gapDesktop },
        1000: { slidesPerView: slidesDesktop, spaceBetween: gapDesktop }
      }
    });
  }

  function initPanels(root) {
    var singleOpen = root.dataset.singleOpen === 'true';
    var speedSeconds = parseFloat(root.dataset.panelSpeed) || 0.3;
    var duration = speedSeconds * 1000;
    var panels = Array.prototype.slice.call(root.querySelectorAll('.values-card__panel'));

    panels.forEach(function (panel) {
      var header = panel.querySelector('.values-card__panel-header');
      if (!header) return;

      header.addEventListener('click', function (event) {
        event.preventDefault();

        var isOpen = panel.hasAttribute('open');

        if (isOpen) {
          animateClose(panel, duration);
          return;
        }

        if (singleOpen) {
          panels.forEach(function (other) {
            if (other !== panel && other.hasAttribute('open')) {
              animateClose(other, duration);
            }
          });
        }

        animateOpen(panel, duration);
      });
    });

    // A resize can change the collapsed/full heights (device breakpoint
    // change); simplest correct behaviour is to close any open panel
    // rather than carry a now-stale animated height forward.
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        panels.forEach(function (panel) {
          if (panel.hasAttribute('open')) {
            panel.removeAttribute('open');
            panel.style.height = '';
          }
        });
      }, 150);
    });
  }

  function animateOpen(panel, duration) {
    var collapsedH = panel.getBoundingClientRect().height;
    var card = panel.closest('.values-card__inner');
    var fullH = card ? card.getBoundingClientRect().height : collapsedH;

    panel.style.overflow = 'hidden';
    panel.setAttribute('open', '');

    var animation = panel.animate(
      [{ height: collapsedH + 'px' }, { height: fullH + 'px' }],
      { duration: duration, easing: 'ease', fill: 'forwards' }
    );

    animation.onfinish = function () {
      panel.style.height = '100%';
    };
  }

  function animateClose(panel, duration) {
    var header = panel.querySelector('.values-card__panel-header');
    var currentH = panel.getBoundingClientRect().height;
    var collapsedH = header ? header.getBoundingClientRect().height : currentH;

    panel.style.height = currentH + 'px';
    // Force reflow so the browser registers the explicit height above
    // before the animation starts from it.
    // eslint-disable-next-line no-unused-expressions
    panel.getBoundingClientRect();

    var animation = panel.animate(
      [{ height: currentH + 'px' }, { height: collapsedH + 'px' }],
      { duration: duration, easing: 'ease', fill: 'forwards' }
    );

    animation.onfinish = function () {
      panel.removeAttribute('open');
      panel.style.height = '';
    };
  }
})();
